/** An error encountered during parsing. */
export type ParseError = {
  line?: number;
  message: string;
};

/** A standardized parse result with typed output and errors. */
export type ParseResult<T> = {
  result: T;
  errors: ParseError[];
};

export function getErrorMessage(
  error: unknown,
  fallback = "Unknown error",
): string {
  return error instanceof Error ? error.message : fallback;
}
